var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal layout center"},[(!_vm.$store.state.isScreenCapture)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipCountUserOnline),expression:"tooltipCountUserOnline"}],staticClass:"count-answer",class:{
      'has-reaction':
        _vm.$store.state.slideActive.type != 'openEnded' &&
        _vm.$store.state.slideActive.type != 'multipleChoice' &&
        _vm.$store.state.slideActive.type != 'wordCloud' &&
        _vm.$store.state.slideActive.type != 'qrcode' &&
        _vm.$store.state.slideActive.type != 'pickAnswer' &&
        _vm.$store.state.slideActive.type != 'leaderboard',
    }},[_c('i',{staticClass:"fas fa-user fa-fw",class:{ 'animate__bounceIn animate__animated': _vm.userCountAnimation },attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"user-online-status",class:{
        online: _vm.$store.state.userOnline > 0,
        'status-border': _vm.$store.state.slideActive.textColour == '#313131',
        warning: _vm.$store.state.onlineStatus == 2,
        danger: _vm.$store.state.onlineStatus == 3,
      }}),_c('span',{staticClass:"ml-0.5"},[_vm._v(_vm._s(_vm._f("formatTotalPoint")((_vm.$store.state.userOnline || 0)))+"\n      "),(
          _vm.$store.state.plan &&
            _vm.$store.state.plan.group != 'white-label' &&
            _vm.$store.state.plan.group != 'pro' &&
            !_vm.$store.state.sharePresentation)?_c('span',{staticClass:"show-limit-online"},[_c('span',{staticClass:"limit-slash"},[_vm._v("/")]),_c('span',{staticClass:"limit-number"}),_vm._v(_vm._s(_vm.$store.state.plan.limit)+"\n      ")]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }